import { createRouter, createWebHistory } from "vue-router"

const Listing = ()=> import(/* webpackChunkName: "Listing" */'@/views/Listing.vue')
const Landing = ()=> import(/* webpackChunkName: "landing" */'@/views/Landing.vue')
const Destiny = ()=> import(/* webpackChunkName: "microsite-destiny" */'@/views/microsites/destiny/Destiny.vue')
const BoseBlitz = ()=> import(/* webpackChunkName: "microsite-boseeBlitz" */'@/views/microsites/bossBlitz/BossBlitz.vue')
const Ignition = ()=> import(/* webpackChunkName: "microsite-ignition" */'@/views/microsites/ignition/Ignition.vue')
const Savior = ()=> import(/* webpackChunkName: "microsite-ignition" */'@/views/microsites/savior/Savior.vue')
const SixthStar = ()=> import(/* webpackChunkName: "microsite-SixthStar" */'@/views/microsites/SixthStar/SixthStar.vue')
const Msf = ()=> import(/* webpackChunkName: "microsite-ignition" */'@/views/microsites/msf/Msf.vue')
const PunchKingWinners = () => /* webpackChunkName: "PunchKingWinners" */ import('@/views/microsites/PunchKingWinners/PunchKingWinners.vue')

const routes = [
  {
    path: "/",
    component: Listing
  },
  {
    path: "/landing",
    component: Landing
  },
  {
    path: "/micro-site/destiny",
    component: Destiny,
  },
  {
    path: "/micro-site/bossblitz",
    component: BoseBlitz,
  },
  {
    path: "/micro-site/ignition",
    component: Ignition,
  },
  {
    path: "/micro-site/savior",
    component: Savior,
  },
  {
    path: "/micro-site/sixthstar",
    component: SixthStar,
  },
  {
    path: "/maplestoryfest",
    component: Msf,
  },
  {
    path: "/rankings/punchking",
    component: PunchKingWinners,
  }
]

const router = createRouter({
    history : createWebHistory(),
    base:"/",
    routes
})

export {
  router,
  routes
};
